import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Environment } from '../types/environment.types';
import { TranslateService } from '@ngx-translate/core';
@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  constructor(
    private http: HttpClient,
    private translateService: TranslateService
  ) {}

  public getAllEnvironments() {
    return this.http.get<Environment[]>(environment.apiUrl + '/environment/');
  }
  public searchEnvironments(searchString: string) {
    return this.http.get<Environment[]>(
      environment.apiUrl + '/environment/?search_str=' + searchString + '&lang=' + this.translateService.getCurrentLang()
    );
  }
}
